import React from "react";
import { useParams } from "react-router-dom";
import productService from "../services/productService";
import { showProcess, hideProcess, getFileServer } from "../utils/util";

function withParams(Component) {
    return (props) => <ProductDetails {...props} params={useParams()} />;
}

class ProductDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            product: null,
            loading: true,
            error: null,
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();
            const response = await productService.getByIdWP(this.props.params.id);

            if (response.status === 200) {
                this.setState({
                    product: response.data,
                    error: null,
                    loading: false,
                });
            } else {
                this.setState({
                    error: "Erro ao carregar o produto",
                    loading: false,
                });
            }
        } catch (err) {
            console.error("Erro ao buscar produto:", err);
            this.setState({
                error: "Erro ao carregar o produto",
                loading: false,
            });
        } finally {
            hideProcess();
        }
    }

    navigateTo = (path) => {
        window.location.href = path;
    };

    render() {
        const { product, loading, error } = this.state;
        const { fileServer } = this.state;

        console.log("Produto carregado:", product);

        if (loading) {
            return (
                <div style={{ textAlign: "center", padding: "40px" }}>
                    <p>Carregando...</p>
                </div>
            );
        }

        if (error || !product) {
            return (
                <div
                    style={{
                        textAlign: "center",
                        padding: "40px",
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <h2 style={{ color: "#d32f2f", marginBottom: "20px" }}>
                        {error || "Produto não encontrado"}
                    </h2>
                    <button
                        onClick={() => this.navigateTo("/")}
                        style={{
                            backgroundColor: "#000141",
                            color: "#fff",
                            border: "none",
                            borderRadius: "25px",
                            padding: "12px 25px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            cursor: "pointer",
                        }}
                    >
                        Voltar para Home
                    </button>
                </div>
            );
        }

        return (
        <div
            style={{
                minHeight: "100vh",
                backgroundColor: "#f5f5f5",
                padding: "20px",
            }}
        >
            
            {/* CONTEÚDO PRINCIPAL */}
            <div
                style={{
                    maxWidth: "1200px",
                    margin: "0 auto",
                    display: "flex",
                    gap: "40px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                }}
            >
                {/* COLUNA 1: IMAGEM */}
                <div
                    style={{
                        flex: "1",
                        minWidth: "280px",
                        maxWidth: "500px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            backgroundColor: "#fff",
                            borderRadius: "15px",
                            padding: "20px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <img
                            src={`${fileServer}/cards/${product.id}.png`}
                            alt={product.displayName}
                            style={{
                                width: "100%",
                                height: "auto",
                                maxHeight: "400px",
                                objectFit: "contain",
                                borderRadius: "10px",
                            }}
                        />
                    </div>
                </div>

                {/* COLUNA 2: INFORMAÇÕES */}
                <div
                    style={{
                        flex: "1",
                        minWidth: "280px",
                        maxWidth: "500px",
                    }}
                >
                    {/* NOME */}
                    <div
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "15px",
                            padding: "25px",
                            marginBottom: "20px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h2
                            style={{
                                color: "#000141",
                                fontSize: "clamp(24px, 5vw, 32px)",
                                margin: "0 0 15px 0",
                            }}
                        >
                            {product.displayName}
                        </h2>
                    </div>

                    {/* VALOR */}
                    <div
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "15px",
                            padding: "25px",
                            marginBottom: "20px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h3
                            style={{
                                color: "#0F1194",
                                fontSize: "18px",
                                margin: "0 0 15px 0",
                            }}
                        >
                            Valor
                        </h3>
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap",
                            }}
                        >
                            {product.childProducts && product.childProducts.length > 0 ? (
                                product.childProducts
                                    .sort((a, b) => a.amount - b.amount)
                                    .map((p) => (
                                        <button
                                            key={p.id}
                                            style={{
                                                border: "2px solid #0F1194",
                                                color: "#0F1194",
                                                padding: "10px 20px",
                                                borderRadius: "20px",
                                                backgroundColor: "#F2F2F2",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "all 0.3s ease",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#C4C5E5";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "#F2F2F2";
                                            }}
                                        >
                                            R$ {p.amount.toFixed(2)}
                                        </button>
                                    ))
                            ) : (
                                <div
                                    style={{
                                        fontSize: "24px",
                                        fontWeight: "bold",
                                        color: "#0F1194",
                                    }}
                                >
                                    R$ {product.amount?.toFixed(2)}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* INSTRUÇÕES DE RESGATE */}
                    {product.egiftRedemptionInstructions && (
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "15px",
                                padding: "25px",
                                marginBottom: "20px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h3
                                style={{
                                    color: "#0F1194",
                                    fontSize: "18px",
                                    margin: "0 0 15px 0",
                                }}
                            >
                                Instruções de Resgate
                            </h3>
                            <p
                                style={{
                                    color: "#333",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    margin: "0",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                }}
                            >
                                {product.egiftRedemptionInstructions}
                            </p>
                        </div>
                    )}

                    {product.activationInstructions && (
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "15px",
                                padding: "25px",
                                marginBottom: "20px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h3
                                style={{
                                    color: "#0F1194",
                                    fontSize: "18px",
                                    margin: "0 0 15px 0",
                                }}
                            >
                                Instruções de Resgate
                            </h3>
                            <p
                                style={{
                                    color: "#333",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    margin: "0",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                }}
                            >
                                {product.activationInstructions.description}
                            </p>
                        </div>
                    )}

                    {/* TERMOS DE USO */}
                    {product.egiftTermsAndConditions && (
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "15px",
                                padding: "25px",
                                marginBottom: "20px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h3
                                style={{
                                    color: "#0F1194",
                                    fontSize: "18px",
                                    margin: "0 0 15px 0",
                                }}
                            >
                                Termos de Uso
                            </h3>
                            <div
                                style={{
                                    color: "#333",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                    padding: "10px",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                }}
                                dangerouslySetInnerHTML={{ __html: product.egiftTermsAndConditions }}
                            />
                        </div>
                    )}
                    {product.termsAndConditions && (
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "15px",
                                padding: "25px",
                                marginBottom: "20px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h3
                                style={{
                                    color: "#0F1194",
                                    fontSize: "18px",
                                    margin: "0 0 15px 0",
                                }}
                            >
                                Termos de Uso
                            </h3>
                            <div
                                style={{
                                    color: "#333",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                    padding: "10px",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                }}
                                dangerouslySetInnerHTML={{ __html: product.termsAndConditions.description }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
        );
    }
}

export default withParams(ProductDetails);
